import React from 'react';

import Typography from '@material-ui/core/Typography';

import { Logo } from 'components';
import AuthBoxImage from 'assets/Forsidebilde_BifrostBooking.svg';

import { useStyles } from './styles';

const AuthLayout = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.authBox}>
        <div className={classes.header}>
          <Logo />
        </div>
        <div className={classes.content}>
          <div className={classes.imageWrapper}>
            <img src={AuthBoxImage} className={classes.image} alt="Logo" />
          </div>
          <div className={classes.contentMain}>{children}</div>
        </div>
        <div className={classes.footer}>
          <Typography variant="body2">
            If you need any help, contact us at <b>post@bifrostbooking.no</b>
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
